module.exports = __webpack_public_path__ + "img/ballons-left.5bdd5809.png";